import React from "react";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { useTheme } from "@mui/material/styles";
import { stripParenthesizedWords } from "../../actprep-ui/utils/formatting";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  p: 4,
};

function TicketPrimaryLabel({ ticket }) {
  return (
    <span style={{ fontWeight: "bold" }}>
      {ticket.student
        ? `${ticket.student.first_name} ${ticket.student.last_name}`
        : "Unassigned"}
    </span>
  );
}

function TicketSecondaryLabel({ ticket }) {
  return (
    <span>
      {stripParenthesizedWords(ticket.program_type)} •{" "}
      {stripParenthesizedWords(ticket.seat_type)}
    </span>
  );
}

const OrderRowModal = ({ open, handleClose, order }) => {
  const muiTheme = useTheme();
  if (!order) {
    return;
  }
  const { parent, tickets, total_paid: totalPaid } = order;

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container sx={style}>
        <Grid size={6}>
          <Typography fontWeight={"bold"} variant="h5" color="primary">
            Info
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="p" color="primary">
                    <strong>Parent:</strong>{" "}
                    {`${parent?.first_name} ${parent?.last_name}`}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="p" color="primary">
                    <strong>Parent Email:</strong> {parent?.email ?? ""}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="p" color="primary">
                    <strong>Total Paid:</strong> {`$${totalPaid}`}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="p" color="primary">
                    <strong>Start Date:</strong>{" "}
                    {`${tickets[0].cohort.event_name.replace(
                      " Start Date",
                      ""
                    )}`}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </Grid>
        <Grid size={6}>
          <Typography fontWeight={"bold"} color="primary" variant="h5">
            Tickets
          </Typography>
          <List>
            {tickets.map((ticket, i) => (
              <ListItemButton key={i} dense>
                <ListItem>
                  <ListItemText
                    sx={{
                      color: muiTheme.palette.text.primary,
                    }}
                    primary={<TicketPrimaryLabel ticket={ticket} />}
                    secondary={<TicketSecondaryLabel ticket={ticket} />}
                  />
                </ListItem>
              </ListItemButton>
            ))}
          </List>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default OrderRowModal;
